<template lang="pug">
  div.full-width
    div(v-show="!isLoading")
      div.d-inline(v-if="!isCreatePage")
        v-chip.mb-2.mr-2.text-capitalize(
          outlined,
          color="primary",
        ) {{ role }}
        v-chip.mb-2.mr-2(
          outlined,
          color="primary",
        ) {{ user.first_name }} {{ user.last_name }}
        v-chip.mb-2.mr-2(
          outlined,
          v-if="!isCreatePage",
          color="primary",
        ) {{ shop.name || 'HQ' }}

      v-chip.mb-2.mr-2(
        outlined,
        v-for="medicalCondition in user.medical_conditions",
        :key="medicalCondition.id",
        color="primary",
      ) {{ stripInitialNumbers(medicalCondition.name) }}

      v-chip.mb-2.mr-2(
        outlined,
        v-for="scalpCondition in user.scalp_conditions",
        :key="scalpCondition.id",
        color="primary",
      ) {{ stripInitialNumbers(scalpCondition.name) }}
      v-chip.mb-2.mr-2(
        outlined,
        v-if="['editUser', 'editStaff'].includes($route.name)",
        color="primary",
      ) Created: {{ formatDate(user.createdAt) }}
    v-card.mt-12.full-width(width="100")
      v-overlay(:value="isLoading")
        v-progress-circular(:value="20" indeterminate)
      Header(
        :icon="isStaffPage ? 'user' : 'users'",
        :to="isStaffPage ? { name: 'staffs' } : { name: 'users' }",
      )
      TabWrapper(
        v-if="!isLoading",
        :tab-arg="{ role: user.role }",
        :type="tabType",
      )
        slot
</template>

<script>
import { propEq } from "ramda";
import { mapGetters } from "vuex";
import { progressWrapper } from "@/config/mixins.js";
import { formatDate, stripInitialNumbers } from "@/utils/helper";

import FormWrapper from "@/components/wrapper/FormWrapper.vue";
import Header from "@/components/forms/Header.vue";
import TabWrapper from "@/components/wrapper/TabWrapper.vue";
import UserForm from "@/components/forms/User.vue";

export default {
  mixins: [progressWrapper],

  components: {
    FormWrapper,
    Header,
    TabWrapper,
    UserForm,
  },

  data: () => ({
    isCreatePage: false,
    role: null,
    tabType: null,
  }),

  computed: {
    ...mapGetters({
      shops: "shop/items",
      user: "user/user",
    }),

    shop() {
      return (
        this.shops.find(propEq("id", this.user.shop_id)) || {
          address: null,
        }
      );
    },

    isStaffPage() {
      return (
        this.$route.name === "createUser" ||
        ["staff", "superadmin"].includes(this.user.role)
      );
    },
  },

  created() {
    const tabTypes = {
      createUser: "userNew",
      createStaff: "staffNew",
    };
    this.tabType = tabTypes[this.$route.name] || "user";
    this.isCreatePage = ["createUser", "createStaff"].includes(
      this.$route.name
    );

    if (!["createUser", "createStaff"].includes(this.$route.name)) {
      this.wrapProgress(() =>
        Promise.all([
          this.$store.dispatch("shop/fetch", {}),
          this.$store.dispatch("medicalCondition/fetch", {
            sortBy: "name",
            sortDesc: false,
          }),
          this.$store.dispatch("scalpCondition/fetch", {
            sortBy: "name",
            sortDesc: false,
          }),
          this.$store.dispatch("mediaTag/fetch", {
            sortBy: "name",
            sortDesc: false,
            limit: 50,
            hardFetch: true,
          }),
          // this.$store.dispatch('redeemable/fetchActive', this.$route.params.id),
          // this.$store.dispatch(
          //   'rewardTemplate/fetchActive',
          //   this.$route.params.id,
          // ),
          this.$store.dispatch("user/find", this.$route.params.id),
          this.$store.dispatch("media/fetch", {
            user_id: this.$route.params.id,
            limit: 1000,
            skip: 0,
          }),
        ])
          .then(() => {
            this.role = this.user.role;
          })
          .catch(() => this.$router.push({ name: "dashboard" }))
      );
    } else {
      this.wrapProgress(() =>
        Promise.all([
          this.$store.dispatch("shop/fetch", {}),
          this.$store.dispatch("medicalCondition/fetch", {}),
          this.$store.dispatch("scalpCondition/fetch", {}),
        ]).catch(() => this.$router.push({ name: "dashboard" }))
      );
    }
  },

  methods: {
    formatDate,
    stripInitialNumbers,
    prepareFetchPayload() {
      return {
        type: "media",
        params: {
          search: this.search,
          hardFetch: true,
        },
      };
    },
  },
};
</script>
